/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Counter — Words, Characters & Reading Time | Toolverse`)
};

const es_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Palabras — Palabras, Caracteres y Tiempo de Lectura | Toolverse`)
};

const de_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wort-Zähler — Wörter, Zeichen und Lesezeit | Toolverse`)
};

const nl_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woordteller — Woorden, Tekens & Leestijd | Toolverse`)
};

const fr_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de mots — Mots, Caractères et Temps de lecture | Toolverse`)
};

const it_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di parole — Parole, Caratteri e Tempo di lettura | Toolverse`)
};

const pt_br2_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Palavras — Palavras, Caracteres e Tempo de Leitura | Toolverse`)
};

const pt_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Palavras — Palavras, Caracteres e Tempo de Leitura | Toolverse`)
};

const ja_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語カウンター — 単語、文字、読む時間 | Toolverse`)
};

const zh_wc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字数统计工具——字数、字符数与阅读时间 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_meta_title", locale)
	if (locale === "en") return en_wc_meta_title(inputs)
	if (locale === "es") return es_wc_meta_title(inputs)
	if (locale === "de") return de_wc_meta_title(inputs)
	if (locale === "nl") return nl_wc_meta_title(inputs)
	if (locale === "fr") return fr_wc_meta_title(inputs)
	if (locale === "it") return it_wc_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_wc_meta_title(inputs)
	if (locale === "pt") return pt_wc_meta_title(inputs)
	if (locale === "ja") return ja_wc_meta_title(inputs)
	return zh_wc_meta_title(inputs)
};